import React from 'react';
import { Team } from '../../types';
import { Card, CardHeader, CardBody } from '../UI/Card';
import { Badge } from '../UI/Badge';
import styles from './TeamCard.module.css';

export interface TeamCardProps {
  team: Team;
}

/**
 * TeamCard component displays a single team with its members
 * 
 * Features:
 * - Displays team name with fire accent styling
 * - Lists all team members with their affiliation badges
 * - Highlights SeDi with special styling
 * - Uses Card component as base
 */
export const TeamCard: React.FC<TeamCardProps> = ({ team }) => {
  return (
    <Card className={styles.teamCard}>
      <CardHeader>
        <h3 className={styles.teamName}>{team.name}</h3>
      </CardHeader>
      <CardBody>
        <ul className={styles.memberList}>
          {team.members.map((member, index) => (
            <li key={index} className={styles.memberItem}>
              <span className={member.name === 'SeDi' ? styles.sediName : styles.memberName}>
                {member.name}
              </span>
              <Badge 
                variant={member.team === 'Special' ? 'fire' : 'default'}
                className={styles.teamBadge}
              >
                {member.team}
              </Badge>
            </li>
          ))}
        </ul>
      </CardBody>
    </Card>
  );
};
